{
  "actions": "Darbības",
  "hideButtonLabel": "Rādīt mazāk",
  "noTags": "Nav",
  "showAllButtonLabel": "Rādīt visu ({tagCount, number})"
}
